import React from 'react';
import PageBanner from '../../components/PageBanner';
import { productionRouteBanners, productionRouteBannerAlts } from '../../constants/sectionBanners';
import './StallDesign.css';

const StallDesign = () => {
  return (
    <div className="stall-design-page">
      <PageBanner
        title="Stall Design"
        image={productionRouteBanners['stall-design']}
        imageAlt={productionRouteBannerAlts['stall-design']}
      />
      
      <section className="section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Stall Design</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Creative and functional stall designs that attract attention and showcase your brand
            </p>
          </div>
          
          <div className="about-content">
            <p>
              Our expert team creates stunning stall designs that effectively represent your brand 
              and attract visitors. From concept to execution, we ensure your stall stands out 
              at exhibitions, trade shows, and events.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StallDesign;
